<template>
    <div>
        <!-- new table -->
        <div style="overflow-x:auto !important;">
            <table class="ship-flow-table-Pich">
                <thead>
                    <tr>
                        <th v-if="confirmableCheck">
                            <input
                                type="checkbox"
                                v-model="isCheckAll"
                                @change="handlerCheckAll"
                            >
                        </th>
                        <th style="min-width:100px;">รหัสลูกค้า</th>
                        <th style="min-width:250px;">ชื่อร้าน</th>
                        <th style="min-width:300px;">ที่อยู่</th>
                        <th class="text-md-center" style="min-width:100px;">เวลาเข้ารับ</th>
                        <th class="text-md-center" style="min-width:120px;">จำนวนชิ้น</th>
                        <th class="text-md-center" style="min-width:120px;">ขนส่ง</th>
                        <th class="text-md-center" style="min-width:150px;">ประเภทเข้ารับ</th>
                        <th class="text-md-center" style="min-width:100px;">Confirm</th>
                        <th class="text-md-center" style="min-width:150px;">อัพเดทล่าสุด</th>
                        <th class="text-md-center" style="min-width:200px;">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(item,index) in tableInfo">
                    <tr :key="index" valign="top">
                        <td v-if="confirmableCheck" style="min-width:20px;">
                            <input
                                    type="checkbox"
                                    :id="item.courierBookingId"
                                    :value="{...item}"
                                    v-model="multipleSelection"
                                    @change="handleSelection"
                                >
                        </td>
                        <td class="text-md-left" style="min-width:100px;">{{item.userCode}}</td>
                        <td class="text-md-left" style="min-width:250px;">
                            <div v-for="(shop,index) in shopNameLineBreak(item.shopName)" :key="index">{{shop}}</div>
                        </td>
                        <td style="min-width:300px;">{{formatShipflowAddress(item.pickupAddress)}}</td>
                        <td class="text-md-center" style="min-width:100px;">{{item.pickupTime}}&nbsp;น.</td>
                        <td class="text-md-center" style="min-width:120px;">
                            {{item.countOrder}}  <el-button type="text" @click="editCount(item.countOrder,index)" v-if="modeCheck === 2">แก้ไข</el-button>
                        </td>
                        <td class="text-md-center" style="min-width:120px;">{{getCourier(item.courierId)}}</td>
                        <td class="text-md-center" style="min-width:150px;">{{getShipflowTypeName(item.type)}}</td>
                        <td class="text-md-center" style="min-width:100px;">
                            <div v-if="isPickedUpCheck">
                                <i v-if="item.isConfirm" class="el-icon-check" type="primary"></i>
                            </div>
                        </td>
                        <td class="text-md-center" style="min-width:150px;">
                            <div v-if="isPickedUpCheck">
                                {{setShipFlowUpdateTime(item.modifiedAt)}}
                            </div>
                            <div v-else>
                                <span>-</span>
                            </div>
                        </td>
                        <td class="text-md-center" style="min-width:200px;">
                            <el-button :disabled="btnDisableCheck" size="small" icon="el-icon-edit" type="primary" plain @click="handleEditBooking(item)"></el-button>
                            <el-button :disabled="cancelBtnDisableCheck" size="small" icon="el-icon-delete" type="danger" plain @click="handleDeleteBooking(item)"></el-button>
                        </td>
                    </tr>
                    </template>
                </tbody>
            </table>
        </div>
        <booking-dialog-delete
            :detail.sync="deleteBookingDetail"/>
        <booking-dialog-form
            :detail.sync="editBookingDetail"
            :is-pickup-type-disable="bookingTypeDetail"/>
    </div>
</template>

<script>
import { eventBus } from '@/main'
import fgApi from '@/services/fillgoods'
import BookingDialogForm from '@/components/Booking/BookingDialog/BookingDialogForm.vue'
import BookingDialogDelete from '@/components/Booking/BookingDialog/BookingDialogDelete.vue'
import mixinExcel from '@/mixins/exportExcel.js'
export default {
    name: 'ShipFlowTable',
    mixins: [mixinExcel],
    components: {
        BookingDialogForm,
        BookingDialogDelete
    },
    props: {
        tableInfo: {
            type: Array,
            default: () => []
        },
        modeCheck: {
            type: Number
        },
        paginationDetail: {
            type: Number,
            default: 1
        }
    },
    data () {
        return {
            tableLoading: false,
            isCheckStatusForm: {
                dialogBookingForm: false
            },
            deleteBookingDetail: {
                isCheckDelete: false,
                data: {}
            },
            editBookingDetail: {
                isCheckEditBooking: false,
                isEditNameBooking: false,
                isSelectAddress: false,
                data: {}
            },
            customerDetail: {
                dialog: false,
                data: {},
                pickupAddressShop: [],
                isSelectAddress: false,
                isCheckDelete: false,
                isCheckEditBooking: false,
                isEditNameBooking: false
            },
            isCheckStatusDelete: {
                dialogBookingDelete: false,
                objIndexDelete: null
            },
            bookingTypeDetail: {
                disable: true
            },
            // new table
            multipleSelection: [],
            isCheckAll: false
            // selectionArray: []
        }
    },
    computed: {
        confirmableCheck () {
            return this.modeCheck === 2 || this.modeCheck === 3 || this.modeCheck === 4
        },
        isPickedUpCheck () {
            return this.modeCheck === 4 || this.modeCheck === 5 || this.modeCheck === 3
        },
        btnDisableCheck () {
            return this.modeCheck === 4 || this.modeCheck === 5 || this.modeCheck === 3 || this.modeCheck === 1
        },
        cancelBtnDisableCheck () {
            return this.modeCheck === 4 || this.modeCheck === 5 || this.modeCheck === 1
        }
    },
    watch: {
        'modeCheck' (val) {
            this.multipleSelection = []
            this.isCheckAll = false
        },
        'paginationDetail' (val) {
            this.isCheckAll = false
            setTimeout(() => {
                let uncheckCount = 0
                console.log('current table::', this.tableInfo)
                for (let index in this.tableInfo) {
                    let hasCheck = this.multipleSelection.filter(e => e.courierBookingId === this.tableInfo[index].courierBookingId)
                    if (hasCheck.length < 1) {
                        uncheckCount += 1
                    }
                }
                console.log('uncheckCount', uncheckCount)
                if (uncheckCount > 0) {
                    this.isCheckAll = false
                } else {
                    this.isCheckAll = true
                }
            }, 600)
        },
        'multipleSelection': {
            deep: true,
            handler (val) {
                this.$store.set('booking/shipFlowSelected', val)
            }
        }
    },
    async created () {
        eventBus.$on('courierBookingConfirm', () => {
            console.log('confirm btn was click!!')
            this.onConfirmCourierBooking()
        })
        eventBus.$on('courierBookingStatusChange', () => {
            console.log('change status btn was click!!')
            this.onCourierBookingStatusChange()
        })
        eventBus.$on('bookingSearch', (val) => {
            this.isCheckAll = false
            this.multipleSelection = []
        })
    },
    methods: {
        async onConfirmCourierBooking () {
            if (this.multipleSelection.length > 0) {
                let param = {
                    courierBookingIds: this.getSelectedBookingIds(this.multipleSelection)
                }
                let resultPacel = this.multipleSelection.map(e => {
                    return { courierBookingId: e.courierBookingId, parcelNumber: e.countOrder }
                })
                try {
                    let res = await fgApi.courier.courierBookingConfirm(param)
                    if (res.success) {
                        let resScg = await fgApi.courier.shipflowCourierBookingScg({ courierBookingIdWithParcel: resultPacel })
                        if (resScg.success) {
                            if (resScg.data.length > 0) {
                                let header = [
                                    [
                                        'OrderDate*',
                                        'ShipperCode*',
                                        'ShipperName*',
                                        'ShipperAddress*',
                                        'ShipperZipcode*',
                                        'ShipperTel*',
                                        'DeliveryDate*',
                                        'CustomerCode',
                                        'Order Time',
                                        'Total Boxes*',
                                        'note',
                                        'Weight Kgs',
                                        'Total CBM',
                                        'COD Amount',
                                        'TrackingNumber',
                                        'sender_identity_fname',
                                        'sender_identity_lname',
                                        'sender_identity_idcardnumber',
                                        'COD_accept',
                                        'CCOD_accept',
                                        'insurance_accept',
                                        'insurance_amount',
                                        'document_return_accept',
                                        'product_return_accept'
                                    ]
                                ]
                                resScg.data.forEach(e => {
                                    let arrData = [
                                        this.$dayjs(e.orderDate).format('DD/MM/YYYY'),
                                        e.shipperCode,
                                        e.shipperName,
                                        e.shipperAddress,
                                        e.shipperZipcode,
                                        e.shipperTel,
                                        this.$dayjs(e.deliveryDate).format('DD/MM/YYYY'),
                                        '',
                                        e.orderTime,
                                        e.totalBox,
                                        e.note
                                    ]
                                    header.push(arrData)
                                })
                                this.saveExcelScgNotify(header, 'SCG-Notify-' + this.$dayjs(new Date()).format('DD-MM-YYYY'))
                            }
                            let resFlash = await fgApi.courier.shipflowCourierBookingFlash({ courierBookingIdWithParcel: resultPacel })
                            if (resFlash.success) {
                                this.$message({
                                    message: 'Selected was confirm!',
                                    type: 'success',
                                    showClose: true
                                })
                                eventBus.$emit('shipflowReload', {})
                            } else {
                                this.$notify.error({
                                    title: 'Error',
                                    message: resFlash.message
                                })
                            }
                        } else {
                            this.$notify.error({
                                title: 'Error',
                                message: resScg.message
                            })
                        }
                    } else {
                        this.$notify.error({
                            title: 'Error',
                            message: res.message
                        })
                    }
                } catch (error) {
                    console.error(error)
                }
            } else {
                console.log('Please select row')
            }
        },
        async onCourierBookingStatusChange () {
            if (this.multipleSelection.length > 0) {
                let param = {
                    courierBookingIds: this.getSelectedBookingIds(this.multipleSelection)
                }
                try {
                    let res = await fgApi.courier.courierBookingChange(param)
                    if (res.success) {
                        this.$message({
                            message: 'Selected was change status!',
                            type: 'success',
                            showClose: true
                        })
                        eventBus.$emit('shipflowReload', {})
                    }
                } catch (error) {
                    console.error(error)
                }
            } else {
                console.log('Please select row')
            }
        },
        getSelectedBookingIds (dataArr) {
            let bookingIds = []
            for (let index in dataArr) {
                bookingIds.push(dataArr[index].courierBookingId)
            }
            return bookingIds
        },
        handleDeleteBooking (data) {
            this.deleteBookingDetail.isCheckDelete = true
            this.deleteBookingDetail.data = { ...data }
            this.deleteBookingDetail.isShipflow = true
            console.log('deleteBookingDetail', this.deleteBookingDetail)
        },
        handleEditBooking (data) {
            console.log('handleEditBooking', data)
            this.editBookingDetail.isCheckEditBooking = true
            this.editBookingDetail.isEditNameBooking = true
            this.editBookingDetail.data = { ...data }
            console.log('this.editBookingDetail', this.editBookingDetail)
        },
        setShipFlowUpdateTime (time) {
            // console.log('setShipFlowUpdateTime', time)
            let formatedDate = '-'
            if (time) {
                formatedDate = `Confirm ${this.$dayjs(time).format('HH:mm น.')}`
            } else {
                formatedDate = '-'
            }
            return formatedDate
        },
        shopNameLineBreak (shop) {
            let shopList = shop.split(', ')
            // return shopList.join('\n')
            return shopList
        },
        validateCountOrder (input) {
            // console.log(input)
            // console.log(Number.isInteger(input))
            const isInt = (value) => {
                var er = /^-?[0-9]+$/
                return er.test(value)
            }
            if (input) {
                if (!input.trimEnd()) {
                    return 'กรุณากรอกสาเหตุที่ต้องแก้ไข'
                } else if (isInt(input)) {
                    return true
                } else {
                    return 'กรุณากรอกสาเหตุที่ต้องแก้ไข'
                }
            } else return 'กรุณากรอกสาเหตุที่ต้องแก้ไข'
        },
        editCount (count, index) {
            this.$prompt('', 'จำนวนออเดอร์', {
                confirmButtonText: 'บันทึก',
                cancelButtonText: 'ยกเลิก',
                inputValidator: this.validateCountOrder
            }).then(async value => {
                this.tableInfo[index].countOrder = parseInt(value.value)
            }).catch(() => {

            })
        },
        // new tale
        handlerCheckAll () {
            if (this.isCheckAll) {
                this.tableInfo.forEach(e => {
                    // selectTableArr.push({ ...e })
                    this.multipleSelection.push({ ...e })
                })
                let removeDuplicateSet = new Set()
                let removeDuplicateArr = this.multipleSelection.filter(e => {
                    let duplicate = removeDuplicateSet.has(e.courierBookingId)
                    removeDuplicateSet.add(e.courierBookingId)
                    return !duplicate
                })
                this.multipleSelection = removeDuplicateArr
                console.log('this.multipleSelection', this.multipleSelection)
            } else {
                // this.multipleSelection = []
                this.tableInfo.forEach(e => {
                    if (this.multipleSelection.findIndex(x => x.courierBookingId === e.courierBookingId) !== -1) {
                        this.multipleSelection.splice(this.multipleSelection.findIndex(x => x.courierBookingId === e.courierBookingId), 1)
                    }
                })
            }
        },
        handleSelection () {
            console.log('new table select', this.multipleSelection)
        }
    }
}
</script>

<style lang="scss" scoped>
    .ship-flow-table-Pich{
        font-family: Sarabun;
        font-size: 14px;
        border-collapse: collapse !important;
        table {
        border-spacing: 0;
        border: 1px solid #ddd;
        }

        th, td {
        text-align: left;
        padding: 8px;
        }

        tr:nth-child(even){background-color: #f2f2f2}

        th {
        background-color: black;
        color: white;
        }
    }
    .shiptable-text-center{
        text-align: center;
    }
    .shipflow-table{
        font-family: 'Sarabun', sans-serif;
        font-size: 14px;
    }
</style>
